<template>
  <section class="project-wrapper">
    <article class="project">
      <h1 class="project__title">{{ project.title.rendered }}</h1>
      <div class="project-header">
        <div class="project-header__informations">
          <h2 class="project-header__title">Infos</h2>
          <ul class="project-header__list no-style">
            <li
              v-for="(information, key) in project.CFS.informations"
              class="project-header__item"
              :key="key"
            >
              {{ information.information }}
            </li>
          </ul>
        </div>
        <cms-content
          class="project-header__description"
          v-html="project.content.rendered"
        ></cms-content>
      </div>
      <div class="project__video-wrapper">
        <div class="project__video-inner">
          <iframe
            class="project__video"
            :src="project.CFS.videoLink"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div
        v-for="(makingOf, key) in project.CFS.makingOf"
        class="project-picture js-observer"
        :class="{ 'project-picture--left': key % 2 === 1 }"
        :key="key"
      >
        <div class="project-picture__wrapper">
          <img :src="makingOf.picture" class="project-picture__picture" />
          <div class="project-picture__mask"></div>
        </div>
      </div>
      <div
        class="project-navigation"
        :class="{
          'has-only-previous': !nextProject,
          'has-only-next': !previousProject,
        }"
      >
        <div v-if="previousProject" class="project-navigation__item">
          <p class="project-navigation__label">Précédent</p>
          <router-link
            :to="{ name: 'Project', params: { slug: previousProject.slug } }"
            class="project-navigation__title"
            active-class=""
          >
            <span class="inner">{{ previousProject.title.rendered }}</span>
          </router-link>
        </div>
        <div v-if="nextProject" class="project-navigation__item">
          <p class="project-navigation__label">Suivant</p>
          <router-link
            :to="{ name: 'Project', params: { slug: nextProject.slug } }"
            class="project-navigation__title"
            active-class=""
          >
            <span class="inner">{{ nextProject.title.rendered }}</span>
          </router-link>
        </div>
      </div>
    </article>
    <div class="project__background"></div>
    <div class="projects__transition js-project-transition"></div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import EventBus from "@/util/EventBus";
import CmsContent from "@/components/CMSContent";

export default {
  name: "project-view",
  props: {
    isDesktop: Boolean,
    scrollContent: Function,
    initObserver: Function,
  },

  components: {
    CmsContent,
  },

  data() {
    return {
      $transition: null,
      $project: null,
      project: null,
      projectKey: null,
      previousProject: null,
      nextProject: null,
    };
  },

  computed: mapState({
    projects: (state) => state.projects,
  }),

  watch: {
    $route() {
      this.onProjectChange();
    },
  },

  beforeMount() {
    const { slug } = this.$route.params;

    this.getProject(slug);
  },

  mounted() {
    EventBus.$on("rAF", this.rAF);

    this.$project = this.$el.querySelector(".project");
    this.$transition = this.$el.querySelector(".js-project-transition");

    this.initObserver();

    TweenMax.set(this.$transition, {
      scaleX: 0,
    });
  },

  destroyed() {
    EventBus.$off("rAF");
  },

  methods: {
    enter(done) {
      TweenLite.from(this.$project, 0.6, {
        autoAlpha: 0,
        ease: Quad.easeOut,
        force3D: true,
        onComplete: done,
        onCompleteScope: this,
      });
    },

    rAF() {
      if (this.isDesktop) {
        this.scrollContent();
      }
    },

    onProjectChange() {
      const animationDuration = this.isDesktop ? 0.8 : 0.6;

      TweenMax.set(this.$transition, { transformOrigin: "100% 50%" });
      TweenMax.to(this.$transition, animationDuration, {
        scaleX: 1,
        force3D: true,
        ease: Quart.easeOut,
        onComplete: this.onProjectChanged,
      });
    },

    onProjectChanged() {
      this.project = null;
      this.previousProject = null;
      this.nextProject = null;

      const { slug } = this.$route.params;
      this.getProject(slug);

      this.resetScroll();

      const animationDuration = this.isDesktop ? 0.9 : 0.6;

      TweenMax.set(this.$transition, { transformOrigin: "0% 50%" });
      TweenMax.to(this.$transition, animationDuration, {
        scaleX: 0,
        delay: 0.4,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: () => {
          this.$parent.setBodyHeight();
          this.resetObserver();
          this.initObserver();

          TweenMax.set(this.$transition, {
            scaleX: 0,
          });
        },
      });
    },

    resetObserver() {
      console.log("resetObserver");

      var $sections = document.querySelectorAll(".js-observer");
      var $section;

      for (var i = 0; i < $sections.length; i++) {
        $section = $sections[i];
        $section.classList.remove("is-visible");
      }
    },

    getProject(slug) {
      const project = this.projects.find((project, key) => {
        this.projectKey = key;
        return project.slug === slug;
      });

      if (!project) {
        this.$router.push({ name: "NotFound" });
      } else {
        this.project = project;
      }

      if (this.projectKey > 0) {
        this.previousProject = this.projects[this.projectKey - 1];
      }

      if (this.projectKey < this.projects.length) {
        this.nextProject = this.projects[this.projectKey + 1];
      }
    },

    resetScroll() {
      window.scrollTo(0, 0);
      this.$parent.resetScroll();
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~include-media/dist/_include-media.scss";

.project {
  position: relative;
  z-index: 50;
  padding-bottom: 255px;
}

.project__title {
  margin-top: 7.5rem;
  margin-bottom: 10.2rem;
  font-size: 4.5em;
  line-height: 1.1;
  text-transform: lowercase;

  @include media("<=tablet") {
    font-size: 48px;
    margin-top: 60px;
    margin-bottom: 82px;
  }

  @include media(">=1300px") {
    margin-left: -2.5rem;
  }
}

.project-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: $roboto-font-stack;
}

.project-header__item {
  & + & {
    margin-top: 10px;
  }
}

.project-header__title {
  font-family: $text-font-stack;
  text-transform: uppercase;
  font-weight: 900;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 17px;
}

.project-header__description {
  max-width: 500px;
  line-height: 2;
}

.project__video-wrapper {
  margin: 90px 0 82px;
}

.project__video-inner {
  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border-bottom: 4px solid transparent;
    border-top: 4px solid $black;
    border-left: 4px solid $black;
    border-right: 4px solid $black;
    animation: spin 1.3s linear infinite;

    @keyframes spin {
      0% {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }
  }

  iframe {
    position: relative;
    z-index: 10;
  }
}

.project__video {
  display: block;
  max-width: 810px;
  height: 500px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.project-picture {
  margin-bottom: 82px;
  max-width: 810px;
  height: 500px;
  margin-left: auto;
  position: relative;

  &.is-visible {
    .project-picture__mask {
      transform: translate3d(100%, 0, 0);
      transition: transform 0.6s $easeInOutQuart;
    }

    .project-picture__wrapper {
      opacity: 1;
      transition: opacity 0.6s $easeOutQuad;
    }

    .project-picture__picture {
      transform: scale(1);
      transition: transform 0.6s $easeInOutQuart;
    }
  }
}

.project-picture__wrapper {
  overflow: hidden;
  opacity: 0;
  transform: translate3d(0, 0, 0);
}

.project-picture__mask {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: $white;
}

.project-picture__picture {
  position: relative;
  width: 100%;
  transform: scale(1.2) translate3d(0, 0, 0);
}

.project-picture--left {
  margin-left: 0;
  margin-right: auto;
}

.project__background {
  position: absolute;
  left: 50%;
  top: -300px;
  bottom: 0;
  width: 100vw;
  height: calc(100% + 300px);
  background-color: $white;
  transform: translate(-50%, 0);
  z-index: 20;
}

.project-navigation {
  display: flex;
  flex-wrap: nowrap;
  padding-top: 125px;

  @include media(">660px") {
    &.has-only-previous {
      justify-content: flex-start;

      .project-navigation__item {
        flex: none;
        width: 50%;
        text-align: left;

        &:before {
          right: 0;
          left: auto;
        }

        .project-navigation__title {
          .inner {
            &:after {
              transform-origin: bottom right;
            }
          }

          &:hover {
            .inner {
              &:after {
                transform-origin: bottom left;
              }
            }
          }
        }
      }
    }

    &.has-only-next {
      justify-content: flex-end;

      .project-navigation__item {
        flex: none;
        width: 50%;
        text-align: right;
      }
    }
  }
}

.project-navigation__item {
  flex: 1;
  font-weight: 800;

  &:last-child {
    text-align: right;
    position: relative;

    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 1px;
      background-color: rgba($grey, 0.5);
    }

    .project-navigation__title {
      .inner {
        &:after {
          transform-origin: bottom left;
        }
      }

      &:hover {
        .inner {
          &:after {
            transform-origin: bottom right;
          }
        }
      }
    }
  }
}

.project-navigation__label {
  margin: 0;
}

.project-navigation__title {
  display: block;
  font-size: 52px;
  margin-top: 0.25em;

  .inner {
    &:after {
      height: 5px;
      bottom: -7px;
    }
  }
}

.projects__transition {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: $white;
  z-index: 200;
}

@include media("<=tablet") {
  .project {
    padding-bottom: 160px;
  }

  .project-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .project-header__description {
    margin-top: 38px;
    margin-bottom: 0;
    max-width: none;
  }

  .project-picture {
    max-width: 600px;
    height: auto;
    margin-bottom: 62px;
  }

  .project__video-wrapper {
    margin-top: 38px;
    margin-left: -$gutter;
    width: calc(100% + #{$gutter * 2});
    margin-bottom: 72px;
  }

  .project__video {
    height: 440px;
  }
}

@include media("<=660px") {
  .project-navigation {
    padding-top: 94px;
    flex-direction: column;
    align-items: center;
  }

  .project-navigation__title {
    font-size: 39px;
  }

  .project-navigation__item {
    flex: 0 0 auto;
    text-align: center !important;

    &:last-child {
      margin-top: 54px;
      &::before {
        display: none;
      }
    }
  }
}

@include media("<=600px") {
  .project-picture__wrapper {
    margin-left: -$gutter;
    width: calc(100% + #{$gutter * 2});
  }
}

@include media("<=phone") {
  .project__video {
    height: 220px;
  }
}
</style>


// WEBPACK FOOTER //
// ProjectView.vue?61e749cd